<app-header [isAlerts]="true"></app-header>
<ion-content>
  <app-manage-alerts-header></app-manage-alerts-header>
  <div
    class="alert-group-card-container"
    *ngIf="viewModel$ | async as viewModel"
    data-cy="notification-preferences-container"
  >
    <div
      class="back-to-dashboard-container"
      *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
      data-cy="back-to-dashboard"
    >
      <ion-icon class="back-to-dashboard-icon" name="chevron-back"></ion-icon
      ><app-breadcrumbs
        [breadcrumbs]="viewModel?.uiState?.breadcrumbs"
      ></app-breadcrumbs>
    </div>
    <span class="alert-group-card-title" data-cy="notification-type-title"
      >{{ ('i18n.notifications.preferences.ALERT_TYPE_' +
      viewModel?.notificationType?.type) | translate }}</span
    >
    <app-alert-group-card
      *ngFor="let group of (viewModel?.notificationType?.groups || [])"
      [alertGroup]="group"
      [availableCustomers]="viewModel?.availableCustomers"
      [user]="viewModel?.user"
      [isInternalUser]="viewModel?.isInternalUser"
      (saveNotificationPreferencesEmitter)="saveNotificationPreferences($event)"
      (manageCustomersEmitter)="manageCustomers(viewModel?.notificationType?.type, group)"
    >
    </app-alert-group-card>
  </div>
  <div
    class="footer-wrapper"
    *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop && (viewModel$ | async)"
    data-cy="footer-wrapper"
  >
    <app-footer></app-footer>
  </div>
</ion-content>
<app-toggle-all-toast
  *ngIf="viewModel$ | async as viewModel"
  [showToast]="viewModel?.uiState?.showToggleAllToast"
  [toastMessage]="viewModel?.uiState?.toggleAllToastMessage"
  (dontShowAgainChange)="onDontShowAgainChange($event.checked, $event.message)"
  (closeToast)="onDontShowAgainChange(false, viewModel?.uiState?.toggleAllToastMessage)"
></app-toggle-all-toast>
